import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cloneDeep from 'lodash/cloneDeep';
import SettingsRules from 'components/SlateViewsSettings/SettingsRules/SettingsRules';
import { logicOperatorTypes } from 'config/constants';

// Flatten hierarchical field tree into a flat array with parent references,
// matching the shape that SettingsRules/RuleFields expects.
var flattenFields = function (fields, parent, result) {
  if (!fields) return [];
  if (!result) result = [];
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    field.isShown = true;
    if (parent) {
      field.parent = parent;
      field.parents = parent.parents.concat([parent]);
    } else {
      field.parents = [];
    }
    result.push(field);
    if (field.children) {
      field.isShowChildren = true;
      flattenFields(field.children, field, result);
    }
  }
  return result;
};

var PassFailCriteria = function (props) {
  var config = props.config;
  var onChange = props.onChange;
  var settingsFields = props.settingsFields;
  var fetchSettingsOperators = props.fetchSettingsOperators;
  var errors = props.errors || {};
  var t = useTranslation().t;

  var criteria = config.passFailCriteria || { mode: null, rules: [], andOr: logicOperatorTypes.AND };
  var mode = criteria.mode;
  var hasRecordsField = !!config.recordsFieldKey;

  var availableFields = useMemo(function () {
    if (!settingsFields || !settingsFields.length) return [];
    return flattenFields(cloneDeep(settingsFields));
  }, [settingsFields]);

  var handleModeChange = function (newMode) {
    onChange('passFailCriteria', Object.assign({}, criteria, { mode: newMode }));
  };

  var handleRulesChange = function (newValue) {
    onChange('passFailCriteria', Object.assign({}, criteria, {
      rules: newValue.rules,
      andOr: newValue.andOr,
    }));
  };

  var rulesValue = {
    rules: criteria.rules || [],
    andOr: criteria.andOr || logicOperatorTypes.AND,
  };

  return (
    <div>
      <div className="inspect-settings-content-header">
        <h3 className="inspect-settings-content-title">{t('inspect:sectionPassFail')}</h3>
        <p className="inspect-settings-content-description">
          {t('inspect:passFailDescription')}
        </p>
      </div>

      <div className={'inspect-pass-fail-mode' + (errors.passOrFail ? ' has-error' : '')}>
        <button
          type="button"
          className={'inspect-mode-btn' + (mode === 'pass' ? ' active' : '')}
          onClick={function () { handleModeChange('pass'); }}
        >
          {t('inspect:passRules')}
        </button>
        <button
          type="button"
          className={'inspect-mode-btn' + (mode === 'fail' ? ' active' : '')}
          onClick={function () { handleModeChange('fail'); }}
        >
          {t('inspect:failRules')}
        </button>
      </div>
      {errors.passOrFail && (
        <div className="slate-text-input-error">{errors.passOrFail}</div>
      )}

      {mode && (
        <p className="inspect-mode-hint">
          {mode === 'pass' ? t('inspect:passRulesHint') : t('inspect:failRulesHint')}
        </p>
      )}

      {mode && (
        <SettingsRules
          value={rulesValue}
          fields={availableFields}
          onChange={handleRulesChange}
          fetchSettingsOperators={fetchSettingsOperators}
          recordsFieldUniquenessIdentifier={hasRecordsField ? config.recordsFieldKey : undefined}
          isRecordListView={hasRecordsField}
          hideEntryDetails={hasRecordsField}
          hideOtherFields={hasRecordsField}
        />
      )}
      {mode && errors.passFailRules && (
        <div className="slate-text-input-error">{errors.passFailRules}</div>
      )}
    </div>
  );
};

PassFailCriteria.propTypes = {
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  settingsFields: PropTypes.array,
  fetchSettingsOperators: PropTypes.func,
};

export default PassFailCriteria;
